module.exports = __webpack_public_path__ + "static/media/award_ceremony.08587528.jpeg";